module.exports = __webpack_public_path__ + "static/fonts/iconfont.eef5c8eb.eot";